var exports = {
  "xg": "NewBranchNameInputGroup__boZrRc",
  "ks": "TextInput__E1zV7K",
  "Bx": "copyButtonContainer__4GGMHo",
  "W4": "CopyToClipboardIconButton__z3xSNa",
};

module.exports = exports;
